// @flow

import React, { type Node } from 'react';
import { getGatewayVoucherUrl, usePendingIncomingPayment } from '@tectonics/prs/incoming-payment';
import { Button } from '@tectonics/look-and-feel/shopify-embedded/atoms';
import styled from 'styled-components';

export function ButtonPrintVoucher(): Node {
  const incomingPayment = usePendingIncomingPayment();
  return (
    <CustomButton
      as="a"
      block
      flat
      href={getGatewayVoucherUrl(incomingPayment)}
      rel="noopener noreferrer"
      size="lg"
      target="_blank"
      type="primary"
    >
      Imprimir Recibo Efecty
    </CustomButton>
  );
}

const CustomButton = styled(Button)`
  font-weight: bold;
  text-transform: uppercase;
  font-size: 12px;
  padding: 10px 2px;
  height: 20px;
  &:hover, &:active {
    color: #fff;
    border-color: #fff;
  }
`;
